export const Suspender = () => {
    throw new Promise(() => {});
};
